module.exports = __webpack_public_path__ + "static/img/advantage5.3413a6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business/advantage5.png
// module id = TVXq
// module chunks = 0